import React from "react";
import { useState } from "react";
import { useEffect } from "react";

export default function LookupField({
	items,
	comparator,
	itemKey = "id",
	renderItem = i => i.id,
	onChange,
	placeholder = "Search for items.."
}) {

	const [inputValue, setInputValue] = useState("");
	const [optionsOpen, setOptionsOpen] = useState(false);
	const [closingOptions, setClosingOptions] = useState(false);

	useEffect(() => {
		let to
		if (closingOptions) {
			to = setTimeout(() => {
				setOptionsOpen(false);
				setClosingOptions(false);
			}, 100);
		}
		return () => {
			if (to) clearTimeout(to);
		}
	}, [closingOptions]);

	return <div className="lookupField">

		<div
			className={`lookupField-choices ${optionsOpen ? "lookupField-choices-open" : "lookupField-choices-closed"}`}
		>
			{items
				.filter(item => comparator(inputValue, item))
				.map(item => {
					const key = typeof itemKey === "string" ? item[itemKey] : itemKey(item);
					return <div
						className="item"
						key={key}
						onClick={e => {
							setOptionsOpen(false);
							onChange(item);
						}}
					>
						{renderItem(item)}
					</div>
				})
			}
		</div>

		<input
			type="text"
			placeholder={placeholder}
			onChange={e => setInputValue(e.target.value)}
			value={inputValue}
			onFocus={e => {
				setOptionsOpen(true);
				setClosingOptions(false);
			}}
			onBlur={e => setClosingOptions(true)}
			style={{ height: 40 }}
		/>


	</div>
}